import React from 'react';
import CartButton from "./CartButton.jsx";
import WishlistButton from "./WishlistButton.jsx";
import SubmitError from "./SubmitError.jsx";

export default function Buttons({
                                    product,
                                    texts,
                                    pointOfSaleIdOverride,
                                    filterTrackingValue,
                                    rankingTrackingValue,
                                    pageViewId,
                                    wishlistEnabled,
                                    fullWidth
                                }) {
    return (
        <>
            <div className="w-full">
                <CartButton
                    texts={texts}
                    product={product}
                    pointOfSaleIdOverride={pointOfSaleIdOverride}
                    filterTrackingValue={filterTrackingValue}
                    rankingTrackingValue={rankingTrackingValue}
                    pageViewId={pageViewId}
                    origin="adp"
                />
            </div>

            {wishlistEnabled && (
                <div className="w-full mt-3">
                    <WishlistButton product={product} texts={texts}/>
                </div>
            )}

            <div className="product__add-to-action-error">
                <SubmitError className="product__add-to-action-error"/>
            </div>
        </>
    );
}
